module.exports = __webpack_public_path__ + "public/img/metamask/background-2.svg";